export default __webpack_public_path__ + "static/media/pn.1c9eed3f.svg";